import { useState } from "react";

import { ChartsContainerWrapper } from "@/components/wrappers";

import { BarChart, AreaChart } from ".";

interface ChartsContainerProps {
  data: any[];
}

const ChartsContainer = ({ data }: ChartsContainerProps) => {
  const [barChart, setBarChart] = useState(true);

  return (
    <ChartsContainerWrapper>
      <h4>Monthly Applications</h4>
      <button type="button" onClick={() => setBarChart(prev => !prev)}>
        {barChart ? "Area Chart" : "Bar Chart"}
      </button>
      {barChart ? <BarChart data={data} /> : <AreaChart data={data} />}
    </ChartsContainerWrapper>
  );
};

export default ChartsContainer;
